// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3Gk59nJuDWKfliG9GPUd53","list-menu":"_3uIpsSnZmp8584Q9iuQzdQ"};